import { render, staticRenderFns } from "./input-tags.vue?vue&type=template&id=d8d6ad96&scoped=true&"
import script from "./input-tags.vue?vue&type=script&lang=js&"
export * from "./input-tags.vue?vue&type=script&lang=js&"
import style0 from "./input-tags.vue?vue&type=style&index=0&id=d8d6ad96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d6ad96",
  null
  
)

export default component.exports